<template>
  <div>
    <d-select v-model="computedValue" placeholder="Select an icon">
      <option v-for="icon in availableIcons" :key="icon" :value="icon">
        {{ icon }}
      </option>
    </d-select>
    <div v-if="computedValue" class="mt-2 flex items-center gap-2">
      <d-icon :icon="computedValue" pack="fad" class="text-lg text-primary-500" />
      <span class="text-sm text-gray-600">Selected: {{ computedValue }}</span>
    </div>
    <p class="text-sm text-gray-800 mt-1 ml-1">
      <a href="https://fontawesome.com/icons?d=gallery&p=2&s=duotone" class="underline" target="_blank" rel="noreferrer noopener">Visit Font Awesome</a> to view the list of available icons.
    </p>
  </div>
</template>

<script>
  export default {
    name: 'FontIconSelector',
    
    props: {
      modelValue: String,
      value: String, // Keep for backward compatibility
    },

    emits: ['update:modelValue'],

    data() {
      return {
        availableIcons: [
          'badge',
          'book',
          'certificate',
          'chart-line',
          'check-circle',
          'copy',
          'edit',
          'file-alt',
          'filter',
          'graduation-cap',
          'heart',
          'home',
          'info-circle',
          'laptop',
          'lightbulb',
          'plus',
          'plus-square',
          'star',
          'tag',
          'tasks',
          'trash',
          'trophy',
          'users',
          'wrench'
        ]
      };
    },

    computed: {
      computedValue: {
        get() {
          return this.modelValue || this.value;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        }
      }
    }
  };
</script>